import React from "react";
import PropTypes from "prop-types";
import SearchableSelect from "../common/SearchableSelect";
import {
  PAYMENT_WATCHDOG_FOLLOW_UP_STATUS_OPTIONS,
  PAYMENT_WATCHDOG_PRIORITY_OPTIONS,
} from "./clientSettlementWatchdog";

function ClientSettlementsReportForm({
  month,
  monthOptions,
  clientId,
  clientOptions,
  showDraft,
  showApproved,
  showNegativeBalanceOnly,
  showEmptyClients,
  watchdog,
  onChange,
  onClearFilters,
}) {
  return (
    <div className="mb-4">
      <div className="form-row align-items-end">
        <div className="col-md-4">
          <SearchableSelect
            label="Miesiac"
            name="month"
            value={month}
            onChange={onChange}
            options={monthOptions}
            placeholder="Wybierz miesiac"
            isClearable={false}
          />
        </div>
        <div className="col-md-4">
          <SearchableSelect
            label="Klient"
            name="clientId"
            value={clientId}
            onChange={onChange}
            options={clientOptions}
            placeholder="Wszyscy"
            clearValue="all"
          />
        </div>
      </div>
      <div className="form-row align-items-end mt-2">
        <div className="col-md-auto">
          <div className="form-group">
            <button
              type="button"
              className={`btn btn-sm mr-2 ${showDraft ? "btn-info" : "btn-outline-secondary"}`}
              aria-pressed={showDraft}
              onClick={() => onChange({ target: { name: "showDraft", value: !showDraft } })}
            >
              Robocze
            </button>
            <button
              type="button"
              className={`btn btn-sm mr-2 ${showApproved ? "btn-info" : "btn-outline-secondary"}`}
              aria-pressed={showApproved}
              onClick={() => onChange({ target: { name: "showApproved", value: !showApproved } })}
            >
              Zatwierdzone
            </button>
            <button
              type="button"
              className={`btn btn-sm mr-2 ${showNegativeBalanceOnly ? "btn-danger" : "btn-outline-secondary"}`}
              aria-pressed={showNegativeBalanceOnly}
              onClick={() => onChange({ target: { name: "showNegativeBalanceOnly", value: !showNegativeBalanceOnly } })}
            >
              Tylko z niedoplata
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary mr-2"
              aria-pressed={showEmptyClients}
              onClick={() => onChange({
                target: {
                  name: "showEmptyClients",
                  value: !showEmptyClients,
                },
              })}
            >
              {showEmptyClients ? "Ukryj pustych klientow" : "Pokaz tez pustych klientow"}
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-dark"
              onClick={onClearFilters}
            >
              Wyczysc filtry
            </button>
          </div>
        </div>
      </div>
      <div className="form-row align-items-end mt-2">
        <div className="col-md-auto">
          <div className="form-group">
            <button
              type="button"
              className={`btn btn-sm mr-2 ${watchdog.enabledOnly ? "btn-danger" : "btn-outline-secondary"}`}
              aria-pressed={watchdog.enabledOnly}
              onClick={() => onChange({
                target: {
                  name: "watchdog.enabledOnly",
                  value: !watchdog.enabledOnly,
                },
              })}
            >
              Tylko zaleglosci
            </button>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group">
            <label htmlFor="watchdog-min-amount" className="d-block">
              Min. zaleglosc
              <input
                id="watchdog-min-amount"
                name="watchdog.minAmount"
                type="number"
                min="0"
                className="form-control form-control-sm"
                value={watchdog.minAmount}
                onChange={onChange}
              />
            </label>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group">
            <label htmlFor="watchdog-min-overdue-days" className="d-block">
              Min. dni po terminie
              <input
                id="watchdog-min-overdue-days"
                name="watchdog.minOverdueDays"
                type="number"
                min="0"
                step="1"
                className="form-control form-control-sm"
                value={watchdog.minOverdueDays}
                onChange={onChange}
              />
            </label>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group">
            <label htmlFor="watchdog-priority" className="d-block">
              Priorytet
              <select
                id="watchdog-priority"
                name="watchdog.priority"
                className="form-control form-control-sm"
                value={watchdog.priority}
                onChange={onChange}
              >
                <option value="">Wszystkie</option>
                {PAYMENT_WATCHDOG_PRIORITY_OPTIONS.map(option => (
                  <option key={option.value} value={option.value}>{option.text}</option>
                ))}
              </select>
            </label>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group">
            <label htmlFor="watchdog-follow-up-status" className="d-block">
              Status obslugi
              <select
                id="watchdog-follow-up-status"
                name="watchdog.followUpStatus"
                className="form-control form-control-sm"
                value={watchdog.followUpStatus}
                onChange={onChange}
              >
                <option value="">Wszystkie</option>
                {PAYMENT_WATCHDOG_FOLLOW_UP_STATUS_OPTIONS.map(option => (
                  <option key={option.value} value={option.value}>{option.text}</option>
                ))}
              </select>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

ClientSettlementsReportForm.propTypes = {
  month: PropTypes.string.isRequired,
  monthOptions: PropTypes.array.isRequired,
  clientId: PropTypes.string.isRequired,
  clientOptions: PropTypes.array.isRequired,
  showDraft: PropTypes.bool.isRequired,
  showApproved: PropTypes.bool.isRequired,
  showNegativeBalanceOnly: PropTypes.bool.isRequired,
  showEmptyClients: PropTypes.bool.isRequired,
  watchdog: PropTypes.shape({
    enabledOnly: PropTypes.bool.isRequired,
    minAmount: PropTypes.string.isRequired,
    minOverdueDays: PropTypes.string.isRequired,
    priority: PropTypes.string.isRequired,
    followUpStatus: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
};

export default ClientSettlementsReportForm;
